<div class="input">
  <p-floatLabel>
      <input id="input" type="text" pInputText [(ngModel)]="name" />
      <label for="input">{{inputLabel}}</label>
  </p-floatLabel>
</div>
<div class="actions">
  <p-button
    size="small"
    severity="secondary"
    label="Cancel"
    (onClick)="close()"
  ></p-button>
  <p-button
    [icon]="completeIcon"
    severity="primary"
    size="small"
    [label]="completeText"
    [disabled]="!name"
    (onClick)="create()"
  ></p-button>
</div>
